import { createReducer, on } from '@ngrx/store';
import { HomeStateInterface } from '../types';
import * as HomeDataActions from './actions';

export const initialState: HomeStateInterface = {
  isLoading: false,
  homeData: null,
  error: '',
};

export const HomeReducers = createReducer(
  initialState,
  on(HomeDataActions.getHomeData, (state) => ({ ...state, isLoading: true })),
  on(HomeDataActions.getHomeDataSuccess, (state, action) => ({
    isLoading: false,
    homeData: {
      firstname: action.firstname ?? null,
      lastname: action.lastname ?? null,
      email: action.email,
      applications: action.applications ?? [],
      applicationToJobMapping: action.applicationToJobMapping ?? [],
    },
    error: '',
  })),
  on(HomeDataActions.getHomeDataAlreadyLoaded, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(HomeDataActions.addAppliedJobsToHomeData, (state, action) => ({
    ...state,
    homeData: {
      firstname: state.homeData?.firstname ?? null,
      lastname: state.homeData?.lastname ?? null,
      email: state.homeData?.email ?? null,
      applications: state.homeData?.applications ?? [],
      applicationToJobMapping: [...state.homeData?.applicationToJobMapping ?? [], {job: action.job, application: action.application}]
    }
  })),
  on(HomeDataActions.removeAppliedJobsToHomeData, (state, action) => ({
    ...state,
    homeData: {
      firstname: state.homeData?.firstname ?? null,
      lastname: state.homeData?.lastname ?? null,
      email: state.homeData?.email ?? null,
      applications: state.homeData?.applications ?? [],
      applicationToJobMapping: (state.homeData?.applicationToJobMapping ?? []).filter(mapping => mapping.application.id != action.application.id)
    }
  })),
  on(HomeDataActions.getHomeDataFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),
  on(HomeDataActions.resetHomeData, (state) => ({
    ...initialState
  }))
);
